<script lang="ts">
    import { Col,Button, Nav, NavItem, NavLink} from "sveltestrap";
    import { Advance, Base, Forms, New, Panding, Rating, Replied, Scrollable, Tables, ToggleSubNav, TreeView } from "../../../utils/Constant/Constant";
    import FeatherIcon from "svelte-feather-icon";
    import { toggleNav, toggleNav1 } from "../../../store";
    let setToggleNav:boolean
    toggleNav.subscribe((value)=>{
        setToggleNav = value
    })
    let setToggleNav1:boolean
    toggleNav1.subscribe((value)=>{
        setToggleNav1 = value
    })
    const handleClick = () => {
        toggleNav.update(value => value = !value)
    }
    const handleClick1 = () => {
        toggleNav1.update(value => value = !value)
    }

</script>
<Col lg="6" class="nav-md-mt">
    <div>
      <h5>{ToggleSubNav}</h5>
    </div>
    <Nav vertical class="icon-lists border navs-icon default-according style-1" >
        <NavItem>
            <NavLink><FeatherIcon icon="box"/>
                <span> {Base}</span>
            </NavLink>
        </NavItem>
        <NavItem>
            <Button class="btn-link text-muted {setToggleNav ? "active" : ""}" on:click={()=>handleClick()} color="light"><FeatherIcon icon="folder-plus"/>
                <span> {Advance}</span>
            </Button>
            <Nav class="collapse {setToggleNav ? "show" : ""}" >
                <NavItem class="pl-navs-inline">
                    <NavLink><i class="fa fa-angle-right"></i>
                        <span> {Scrollable}</span>
                    </NavLink>
                </NavItem>
                <NavItem class="pl-navs-inline">
                    <NavLink><i class="fa fa-angle-right"></i>
                        <span> {TreeView}</span>
                    </NavLink>
                </NavItem>
                <NavItem class="pl-navs-inline">
                    <NavLink><i class="fa fa-angle-right"></i>
                        <span> {Rating}</span>
                    </NavLink>
                </NavItem>
            </Nav>
        </NavItem>
        <NavItem>
            <NavLink><FeatherIcon icon="file-text"/>
                <span> {Forms}</span>
            </NavLink>
        </NavItem>
        <NavItem>
            <Button class="btn-link text-muted pb-0 {setToggleNav1 ? "active" : ""}" on:click={()=>handleClick1()} color="light"><FeatherIcon icon="server"/>
                <span> {Tables}</span>
            </Button>
            <Nav vertical class="collapse {setToggleNav1 ? "show" : ""}" >
                <NavItem class="pl-navs-inline">
                    <NavLink><i class="fa fa-angle-right"></i>
                        <span> {New}</span>
                    </NavLink>
                </NavItem>
                <NavItem class="pl-navs-inline">
                    <NavLink><i class="fa fa-angle-right"></i>
                        <span> {Replied}</span>
                    </NavLink>
                </NavItem>
                <NavItem class="pl-navs-inline">
                    <NavLink><i class="fa fa-angle-right"></i>
                        <span> {Panding}</span>
                    </NavLink>
                </NavItem>
            </Nav>
        </NavItem>
    </Nav>
</Col>